module.exports = __webpack_public_path__ + "84a22953e395164cec55b11242d9c4f6.svg";